// CustomerTypeReducer.js — Manufacturer Module, Customer Classification.
// Backs the Customer Types settings screen and the customer_type_id
// dropdown on the manufacturer Customer form. Wired into rootReducer.js
// as `customerType`.

const initialState = {
  types: [],
  loading: false,
  actionLoading: false,
  error: null
};

const CustomerTypeReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'FETCH_CUSTOMER_TYPES_REQUEST':
      return { ...state, loading: true, error: null };
    case 'FETCH_CUSTOMER_TYPES_SUCCESS':
      return { ...state, loading: false, types: action.payload, error: null };
    case 'FETCH_CUSTOMER_TYPES_FAILURE':
      return { ...state, loading: false, error: action.payload };

    case 'CREATE_CUSTOMER_TYPE_REQUEST':
    case 'UPDATE_CUSTOMER_TYPE_REQUEST':
    case 'DELETE_CUSTOMER_TYPE_REQUEST':
      return { ...state, actionLoading: true, error: null };

    case 'CREATE_CUSTOMER_TYPE_SUCCESS':
      return {
        ...state,
        actionLoading: false,
        types: action.payload ? [...state.types, action.payload] : state.types
      };

    case 'UPDATE_CUSTOMER_TYPE_SUCCESS':
      return {
        ...state,
        actionLoading: false,
        types: state.types.map((t) => (t.id === action.payload?.id ? { ...t, ...action.payload } : t))
      };

    case 'DELETE_CUSTOMER_TYPE_SUCCESS':
      return {
        ...state,
        actionLoading: false,
        types: state.types.filter((t) => t.id !== action.payload)
      };

    case 'CREATE_CUSTOMER_TYPE_FAILURE':
    case 'UPDATE_CUSTOMER_TYPE_FAILURE':
    case 'DELETE_CUSTOMER_TYPE_FAILURE':
      return { ...state, actionLoading: false, error: action.payload };

    default:
      return state;
  }
};

export default CustomerTypeReducer;
